import api from './api';

export const getShortLinkDomains = (page, searchTerm, searchItem) => {
  return api.get('admin/short-link-domains', { params: { page, searchTerm, searchItem } });
};

export const updateShortLinkDomain = (domainId, channelUid, data) => {
  return api.put(`admin/short-link-domains/${domainId}`, { channelUid, data });
};

export const deleteShortLinkDomain = (domainId, channelUid) => {
  return api.delete(`admin/short-link-domains/${domainId}`, { data: { channelUid } });
};
